var moment = require('moment')
var i18n = require('i18n')

module.exports = function getDisplayDate(date) {
    var format = i18n.locale() === 'en_US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
    return moment(date).format(format)
}
